<template>
  <Public header="custom-header"
          headerText="เลือกการใช้งาน"
          bg="tw-bg-light-gray"
          headerSubText="เลือกแพ็คเกจที่เหมาะกับคุณ">

    <ref-code className="tw-flex tw-flex-col tw-text-center tw-my-16 tw-justify-center"></ref-code>
    <div class="tw-bg-white">
      <div class="tw-container tw-mx-auto tw-text-center tw-p-5">
        <package-option :on-select-package="onSelectPackage" :is-setting="false"></package-option>
      </div>
    </div>
    <alert-package></alert-package>
    <footer-web></footer-web>
  </Public>
</template>

<script>
import {mapState} from 'vuex'
import FooterWeb from '@/components/public/footer'
import Public from '@/components/public/public-main-template'
import PackageOption from '@/components/company/package'
import RefCode from '@/components/company/ref-code'
import AlertPackage from '../../components/company/alert.package'
import router from "@/router";
import updatePackage from "@/libs/updatePackage";

const _ = require('lodash');

export default {
  name: 'SelectPackage',
  components: {
    FooterWeb,
    Public,
    PackageOption,
    AlertPackage,
    RefCode
  },
   data: function () {
    return {
      selectPackageLoading: false
    }
  },
  computed: mapState({
    companies: state => state.companies.list,
  }),
  created() {
    this.$store.dispatch('companies/getList')
  },
  methods: {
    checkEmptyCompany: function () {
      return !_.isEmpty(this.companies[0]['company'])
    },
    onChangeShowDialog: function (value){
      this.showDialog = value
    },
    onSelectPackage: async function (packageID, refCodeObject) {
      if (this.selectPackageLoading) return
      this.selectPackageLoading = true
      let companyID = this.$route.params.companyId
      let packageObject = {paymentPlanID: packageID, partnerID: ""}
      if (refCodeObject) {
        packageObject.partnerID = refCodeObject['id'];
      }
      if (companyID) {
        await updatePackage(packageObject, companyID, true).then((response) => {
          if (response.status === 200) {
            router.push('buy-certification')
          }
          this.selectPackageLoading = false
        })
      }
    },
  },
}
</script>
